<template>
  <el-dialog
    :visible.sync="dialogFormVisile"
    :title="isEdit ? $t('dialog.productUpdate') : $t('dialog.productAddExcel')"
    width="1000px"
    :close-on-click-modal="false"
  >
    <div class="das-info-title mt-0 mb-10">Danh sách lỗi</div>
    <div style="height: 300px">
      <GridVx
        ref="agGrid"
        :columns="errorExcelUploadCols"
        :rows="errorExcelUploadRows"
        class="agGrid"
        dom-layout="scroll"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogFormVisile = false"
        >
          Đóng
        </button>
        <button class="btn primary small" @click="getListTemplate">
          Tải mẫu
        </button>
        <FileInput
          ref="uploadFile"
          title="Chọn tệp tin"
          @onSelectFile="onSelectUploadList"
        />
      </div>
    </span>
  </el-dialog>
</template>

<script>
import bus from '@/utils/bus'
import FileInput from '@/components/ui/FileInput.vue'
import { downloadFile } from '@/utils/file-handler'
import {
  getProductTemplateExcelApi,
  addProductExcelApi
} from '@/api/configuration/accounting/product/product.js'
export default {
  components: {
    FileInput
  },
  data() {
    return {
      dialogFormVisile: false,
      isEdit: false,
      errorExcelUploadCols: [
        {
          headerName: '#',
          field: 'row_index',
          maxWidth: 80
        },
        {
          headerName: 'Mã sản phẩm',
          field: 'code',
          tooltipField: 'code',
          maxWidth: 150
        },
        {
          headerName: 'Tên tiếng Việt',
          field: 'name',
          tooltipField: 'name',
          maxWidth: 150
        },
        {
          headerName: 'Tên tiếng Anh',
          field: 'eng_name',
          tooltipField: 'eng_name',
          maxWidth: 150
        },
        {
          headerName: 'Đơn vị chính',
          field: 'product_cal_unit_unit',
          tooltipField: 'product_cal_unit_unit',
          maxWidth: 150
        },
        {
          headerName: 'Tỷ lệ quy đổi về đơn vị chính',
          field: 'convert_rate',
          tooltipField: 'convert_rate',
          minWidth: 220
        },
        {
          headerName: 'Phép tính chuyển đổi',
          field: 'calculation',
          tooltipField: 'calculation',
          maxWidth: 200
        },
        {
          headerName: 'Loại sản phẩm',
          field: 'type',
          tooltipField: 'type',
          maxWidth: 150
        },
        {
          headerName: 'Mã danh mục',
          field: 'product_port_folio_code',
          tooltipField: 'product_port_folio_code',
          maxWidth: 150
        },
        {
          headerName: 'Giá chung',
          field: 'price',
          valueGetter: param => {
            return this.$displayCurrency(param?.data?.price) || null
          },
          maxWidth: 150
        },
        {
          headerName: 'Là sản phẩm mua hàng nhanh',
          field: 'quick_purchase',
          minWidth: 250
        },
        {
          headerName: 'Là sản phẩm mở',
          field: 'is_open'
        },
        {
          headerName: 'Ngừng sử dụng',
          field: 'stop_using'
        },
        {
          headerName: 'Đơn vị chuyển đổi',
          field: 'convert_unit'
        },
        {
          headerName: 'Ghi chú',
          field: 'errorDetail',
          tooltipField: 'errorDetail',
          wrapText: true,
          minWidth: 500,
          autoHeight: true,
          cellStyle: { whiteSpace: 'pre' }
        }
      ],
      errorExcelUploadRows: []
    }
  },
  watch: {
    dialogFormVisile() {
      this.dialogFormVisile ? null : this.resetAddListExcelDialog()
    }
  },
  mounted: {},
  methods: {
    resetAddListExcelDialog() {
      this.errorExcelUploadRows = []
    },
    async getListTemplate() {
      bus.$emit('startLoader', { msg: '' })
      await getProductTemplateExcelApi()
        .then(res => {
          downloadFile(res, 'product_template.xlsx')
          this.$message({
            message: 'Tải mẫu thành công',
            type: 'success'
          })
        })
        .catch(error => {
          const msg = error.response.data
          this.$message({
            message: this.$t(msg),
            type: 'error'
          })
        })
      bus.$emit('endLoader')
    },
    async onSelectUploadList(data) {
      const file = data[0]
      this.$refs.uploadFile.resetFile()
      const formData = new FormData()
      formData.append('file', file)
      const array = []
      await addProductExcelApi(formData).then(res => {
        if (res.data) {
          res.data.forEach(item => {
            const errorList = item.list_error.map(item => {
              return `${this.$t(`grid.column.${item.column_name}`)} ${this.$t(
                `errorMsg.${item.error_detail}`
              )}`
            })
            const errorJoined = errorList.join('\n')
            item.product_excel.errorDetail = errorJoined
            item.product_excel.rowIndex = item.list_error[0].rowIndex
            array.push(item.product_excel)
            this.errorExcelUploadRows = array
          })
          this.$message({
            message: this.$t('errorMsg.uploadNotSuccess'),
            type: 'error'
          })
        } else {
          if (res && res.message === 'importProductExcelFileSuccess') {
            this.$message({
              message: this.$t('successMsg.importProductExcelFileSuccess'),
              type: 'success'
            })
            this.dialogFormVisile = false
            this.$emit('uploadSuccess')
          }
        }
      })
    }
  }
}
</script>
